<script setup lang="ts">
import { onMounted } from "vue";

import SuffixInput from "@/components/input/SuffixInput.vue";
import { labelInputKey } from "@/components/input/injectKeys";
import type Duration from "@/utils/Duration";
import { injectStrict } from "@/utils/vue";

defineProps<{ duration: Duration }>();
const emit = defineEmits<{ duration: [Duration] }>();

const labelInput = injectStrict(labelInputKey);

onMounted(() => {
  labelInput.setId("duration");
});
</script>

<template>
  <div class="time">
    <SuffixInput
      id="duration"
      :value="duration.hourStr"
      type="int"
      :max-length="2"
      :suffix="$t('timer.hour')"
      :aria-label="$t('label.timerPanel.durationHours')"
      @change="emit('duration', duration.withHours(+$event))"
    />
    <SuffixInput
      :value="duration.minuteStr"
      type="int"
      :max-length="2"
      :suffix="$t('timer.minute')"
      :aria-label="$t('label.timerPanel.durationMinutes')"
      @change="emit('duration', duration.withMinutes(+$event))"
    />
    <SuffixInput
      :value="duration.secondStr"
      type="int"
      :max-length="2"
      :suffix="$t('timer.second')"
      :aria-label="$t('label.timerPanel.durationSeconds')"
      @change="emit('duration', duration.withSeconds(+$event))"
    />
  </div>
</template>

<style lang="scss">
.time {
  display: flex;
  justify-content: space-between;
  gap: 10px;
}
</style>
